import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { findMenuContext } from "../../constants/menuConstants";
import { ThemeToggle } from "../../ui/Brand";

const useClock = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);
  return now;
};

/** Desktop top bar: where you are, today's date, theme switch. */
const Topbar = () => {
  const location = useLocation();
  const ctx = findMenuContext(location.pathname);
  const now = useClock();
  const isDetail = ctx && ctx.item.to !== location.pathname;

  return (
    <header className="hidden sm:flex items-center gap-3 h-16 px-6 lg:px-8 border-b border-cm-border sticky top-0 z-30 backdrop-blur-md" style={{ background: "color-mix(in srgb, var(--cm-bg) 85%, transparent)" }}>
      <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-[13px] min-w-0">
        {ctx ? (
          <>
            <span className="text-cm-muted truncate">{ctx.group.title}</span>
            <ChevronRight size={14} className="text-cm-faint shrink-0" aria-hidden="true" />
            <span className={isDetail ? "text-cm-muted truncate" : "text-cm-text font-semibold truncate"}>{ctx.item.label}</span>
            {isDetail && (
              <>
                <ChevronRight size={14} className="text-cm-faint shrink-0" aria-hidden="true" />
                <span className="text-cm-text font-semibold">Details</span>
              </>
            )}
          </>
        ) : (
          <span className="text-cm-text font-semibold">ChipMonk</span>
        )}
      </nav>
      <div className="flex-1" />
      <time className="hidden md:block text-[13px] text-cm-muted tabular-nums" dateTime={now.toISOString()}>
        {now.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" })} ·{" "}
        {now.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit" })}
      </time>
      <ThemeToggle />
    </header>
  );
};

export default Topbar;
